/**
 * Helpers for handling user surveys
 */

import { getSurveyAnswered } from '@/providers/laundryheap/api';
import { userData } from '@/helpers/utils';

/* Change this to point to the survey URL */
export const CURRENT_SURVEY_URL = 'https://form.typeform.com/to/YBdMN3aP';

/* This can be any id used to identify survey on our backend.
 * Based on this id, we check if the survey was completed */
export const CURRENT_SURVEY_ID = 'YBdMN3aP';

/**
 * Open the survey in a browser, appending user id as a hash parameter.
 * This is the *only* function that is called to open the survey.
 */
export function openSurvey(): void {
  const userId = userData.data?.id || 'unknown';
  const surveyUrl = `${CURRENT_SURVEY_URL}#user_id=${userId}&lh_external_browser=true`;
  window.open(surveyUrl, '_blank', 'noreferrer');
}

let surveyAnsweredCached = false;

/**
 * Check if the survey has been answered.
 * If yes, result is cached for future calls.
 */
export async function isSurveyAnswered(): Promise<boolean> {
  if (surveyAnsweredCached) {
    return surveyAnsweredCached;
  }
  surveyAnsweredCached = await getSurveyAnswered(CURRENT_SURVEY_ID);
  return surveyAnsweredCached;
}
